<div  v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div class="matrix_packingOptionLabel">{{ name }}</div>
    <input :value="option" type="text" v-on:keydown.enter="(event) => { event.preventDefault(); }" v-on:input="updateOptionAddFlag"/>
</div>
